/**
 * Hands the chat widget's usage events to Google Tag Manager.
 *
 * Tag Manager forwards `chat_*` events to Google Analytics and Clarity, which
 * are not covered for health information. The widget's events carry counts and
 * outcomes only, never message text, and this adds just the name of the step
 * the visitor is on. The branch part of a step id is left out because it can
 * follow from the visitor's answers (an income branch, for example); the case
 * id and the conversation id are never sent.
 */

import type { ChatEvent } from '@resolve/chat-widget';

import { getStepName } from '@/utils/stepUtils';

export const reportChatEvent = (event: ChatEvent, stepId: string | undefined): void => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    ...event,
    event: event.name,
    step: stepId ? getStepName(stepId) ?? 'unknown' : 'none',
  });
};
